export const hidden = [`none`, `none`, `block`];
